<template>
  <b-skeleton-wrapper :loading="isLoading">
    <template #loading>
      <b-row>
        <b-col>
          <b-skeleton width="50%" />
          <b-skeleton width="25%" />
        </b-col>
      </b-row>
    </template>
    <ReadOnly :items="items" />
  </b-skeleton-wrapper>
</template>

<script>
import { formatNumber } from '@/helpers/format-number.js'

import ReadOnly from './index'
import { boxCapacityReadOnly } from '../../lib/constants/read-only-items'

export default {
  components: {
    ReadOnly,
  },
  inject: ['isLoading'],
  props: {
    boxCapacity: {},
  },
  computed: {
    items() {
      return boxCapacityReadOnly(this.$t.bind(this)).map((item) => ({
        ...item,
        value: item.key === 'boxCapacity' && this.boxCapacity != null
          ? `${formatNumber(this.boxCapacity)} Kg`
          : '-',
      }))
    },
  },
}
</script>
